import Vue from 'vue'
import Router from 'vue-router'
import Login from '../views/Login.vue'
import Users from '../views/Users.vue'
import Customers from '../views/Customers.vue'
import Contacts from '../views/Contacts.vue'
import Locations from '../views/Locations.vue'
import Owners from '../views/Owners.vue'
import Countries from '../views/Countries.vue'

import ActivateReturnShop from '../views/returnShopPortals/Activate.vue'
import ReturnShopPortalsOuter from '../views/returnShopPortals/Outer.vue'
import ReturnShopPortalsList from '../views/returnShopPortals/List.vue'
import ReturnShopPortalsGetOuter from '../views/returnShopPortals/GetOuter.vue'
import ReturnShopPortalsGet from '../views/returnShopPortals/Get.vue'
import ReturnShopPortalsAppearance from '../views/returnShopPortals/Appearance.vue'
import ReturnShopPortalsSettings from '../views/returnShopPortals/Settings.vue'
import ReturnShopPortalsPreadviseSettings from '../views/returnShopPortals/PreadviseSettings.vue'
import ReturnShopPortalsTexts from '../views/returnShopPortals/Texts.vue'
import ReturnShopPortalsMappings from '../views/returnShopPortals/Mappings.vue'
import ReturnShopPortalsParcelNumberContainers from '../views/returnShopPortals/ParcelNumberContainers.vue'
import ReturnShopPortalsInstructionsDocument from '../views/returnShopPortals/ReturnShopPortalsInstructionsDocument.vue'

import ShowReturns from '../views/ShowReturns.vue'
import GetReturn from '../views/GetReturn.vue'
import ShowParcelNumberContainers from '../views/ShowParcelNumberContainers.vue'
import GetParcelNumberContainer from '../views/GetParcelNumberContainer.vue'
import GetParcelNumberContainerTabs from '../views/GetParcelNumberContainerTabs.vue'
import GetParcelNumberRange from '../views/GetParcelNumberRange.vue'
import GetReturnportalParcelnumberContainers from '../views/GetReturnportalParcelnumberContainers.vue'
import GetCustomer from '../views/GetCustomer.vue'
import GetContact from '../views/GetContact.vue'

import ImportContactsCustomer from '../views/ImportContactsCustomer'
import CreateContactsCustomer from '../views/CreateContactsCustomer'

import EditTextsForm from '../views/EditTextsForm.vue'

import Dashboard from '../views/Dashboard.vue'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      component: Dashboard
    },
    {
      path: '/login',
      component: Login,
      name: 'login'
    },
    {
      path: '/users',
      component: Users
    },
    {
      path: '/customers',
      component: Customers
    },
    {
      path: '/customers/:id',
      component: GetCustomer
    },
    {
      path: '/contacts',
      component: Contacts
    },
    {
      path: '/contacts/:id',
      component: GetContact
    },
    {
      path: '/locations',
      component: Locations
    },
    {
      path: '/owners',
      component: Owners
    },
    {
      path: '/countries',
      component: Countries
    },
    {
      path: '/returnshopportals',
      component: ReturnShopPortalsOuter,
      children: [
        {
          path: '',
          component: ReturnShopPortalsList
        },
        {
          path: 'activate',
          component: ActivateReturnShop,
          children: [{
            path: ':customerId',
            abstract: true
          }]
        },
        {
          path: ':returnShopPortalId',
          component: ReturnShopPortalsGetOuter,
          meta: {
            sidebar: [{ title: 'Appearance', path: './appearance' }]
          },
          children: [
            {
              path: '',
              component: ReturnShopPortalsGet
            },
            {
              path: 'appearance',
              component: ReturnShopPortalsAppearance
            },
            {
              path: 'settings',
              component: ReturnShopPortalsSettings
            },
            {
              path: 'preadviseSettings',
              component: ReturnShopPortalsPreadviseSettings
            },
            {
              path: 'texts/:app',
              component: ReturnShopPortalsTexts,
              children: [
                {
                  path: ':level1/:level2?',
                  component: EditTextsForm
                }
              ]
            },
            {
              path: 'mappings',
              component: ReturnShopPortalsMappings
            },
            {
              path: 'parcelnumbercontainers',
              component: ReturnShopPortalsParcelNumberContainers
            },
            {
              path: 'instructionsdocument',
              component: ReturnShopPortalsInstructionsDocument
            }
          ]
        }
      ]
    },
    {
      path: '/returns',
      component: ShowReturns
    },
    {
      path: '/returns/:id',
      component: GetReturn
    },

    {
      path: '/parcelnumbercontainers',
      component: ShowParcelNumberContainers
    },
    {
      path: '/parcelnumbercontainers/:id/tabs',
      component: GetParcelNumberContainerTabs,
      children: [
        {
          path: 'container',
          component: GetParcelNumberContainer
        },
        {
          path: 'parcelnumberranges',
          component: GetParcelNumberRange
        },
        {
          path: 'parcelnumberportals',
          component: GetReturnportalParcelnumberContainers
        }
      ]
    },
    {
      path: '/import',
      component: ImportContactsCustomer
    },
    {
      path: '/create',
      component: CreateContactsCustomer
    }
  ]
})



// WEBPACK FOOTER //
// ./client/router/index.js